<template>
	<b-row>
		<b-col>
			<span class="h4 mt-0 mr-4">{{Character.Bio['Character Name']}}</span>
			<span class="lead">{{Character.Bio.Gender}} {{Character.Bio.Race.Name}} {{Character.Bio.Theme}} {{Character.Bio.ShortDescription}}</span>
		</b-col>
	</b-row>
</template>

<script>
export default {
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>